<template>
  <AddressPage path="district" />
</template>
